import React from 'react';

const CategoryChip = ({ label, color = 'bg-blue-100 text-blue-700', icon: Icon, variant = 'filled', className = '' }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold ${variant === 'filled' ? color : `border ${color.replace('bg-', 'border-')} bg-transparent`} ${className}`}>
    {Icon && <Icon className='w-3 h-3 mr-1' />}
    {label}
  </span>
);

export default CategoryChip; 